
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { bulidUid } from '@/libs/util.js'
import { Getter, Mutation } from 'vuex-class'
@Component
export default class TtzTable extends Vue {
    //推筒子1010//二八杆1016
    table = {
        data: [],
        column: [
            {
                key: 'dealer',
                title: '下注顺门庄',
                align: 'center',
                render: (h, params) => {
                    let str: any
                    if (JSON.parse(params.row.opt_detail).hits.hits['1']) {
                        str = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits['1'].bet)
                    }
                    return h('div', [h('p', { style: { color: 'red', height: '20px' } }, str)])
                }
            },
            {
                key: 'heart',
                title: '下注顺门闲',
                align: 'center',
                render: (h, params) => {
                    let str: any
                    if (JSON.parse(params.row.opt_detail).hits.hits['2']) {
                        str = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits['2'].bet)
                    }
                    return h('div', [h('p', { style: { color: 'red', height: '20px' } }, str)])
                }
            },
            {
                key: 'diamond',
                title: '下注天门庄',
                align: 'center',
                render: (h, params) => {
                    let str: any
                    if (JSON.parse(params.row.opt_detail).hits.hits['3']) {
                        str = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits['3'].bet)
                    }
                    return h('div', [h('p', { style: { color: 'red', height: '20px' } }, str)])
                }
            },
            {
                key: 'club',
                title: '下注天门闲',
                align: 'center',
                render: (h, params) => {
                    let str: any
                    if (JSON.parse(params.row.opt_detail).hits.hits['4']) {
                        str = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits['4'].bet)
                    }
                    return h('div', [h('p', { style: { color: 'red', height: '20px' } }, str)])
                }
            },
            {
                key: 'spade',
                title: '下注后门庄',
                align: 'center',
                render: (h, params) => {
                    let str: any
                    if (JSON.parse(params.row.opt_detail).hits.hits['5']) {
                        str = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits['5'].bet)
                    }
                    return h('div', [h('p', { style: { color: 'red', height: '20px' } }, str)])
                }
            },
            {
                key: 'spade',
                title: '下注后门闲',
                align: 'center',
                render: (h, params) => {
                    let str: any
                    if (JSON.parse(params.row.opt_detail).hits.hits['6']) {
                        str = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits['6'].bet)
                    }
                    return h('div', [h('p', { style: { color: 'red', height: '20px' } }, str)])
                }
            },
            {
                key: 'spade',
                title: '顺门牌型',
                align: 'center',
                render: (h, params) => {
                    let poker = []
                    if (JSON.parse(params.row.opt_detail).award_content) {
                        poker = JSON.parse(params.row.opt_detail).award_content.point['1'].poker
                    }
                    return h('div', [
                        h('div', {
                            style: {
                                marginTop: '5px'
                            },
                            domProps: {
                                innerHTML: poker.map((x, index) => {
                                    return "<img style='width:35px;' src=img/poker/MJ/mingmah_" + (x == 10 ? 47 : Number(x) + 30) + '.png>'
                                })
                            }
                        })
                    ])
                }
            },
            {
                key: 'spade',
                title: '天门牌型',
                align: 'center',
                render: (h, params) => {
                    let poker = []
                    if (JSON.parse(params.row.opt_detail).award_content) {
                        poker = JSON.parse(params.row.opt_detail).award_content.point['2'].poker
                    }
                    return h('div', [
                        h('div', {
                            style: {
                                marginTop: '5px'
                            },
                            domProps: {
                                innerHTML: poker.map((x, index) => {
                                    return "<img style='width:35px;' src=img/poker/MJ/mingmah_" + (x == 10 ? 47 : Number(x) + 30) + '.png>'
                                })
                            }
                        })
                    ])
                }
            },
            {
                key: 'spade',
                title: '后门牌型',
                align: 'center',
                render: (h, params) => {
                    let poker = []
                    if (JSON.parse(params.row.opt_detail).award_content) {
                        poker = JSON.parse(params.row.opt_detail).award_content.point['3'].poker
                    }
                    return h('div', [
                        h('div', {
                            style: {
                                marginTop: '5px'
                            },
                            domProps: {
                                innerHTML: poker.map((x, index) => {
                                    return "<img style='width:35px;' src=img/poker/MJ/mingmah_" + (x == 10 ? 47 : Number(x) + 30) + '.png>'
                                })
                            }
                        })
                    ])
                }
            },
            {
                key: 'spade',
                title: '庄牌型',
                align: 'center',
                render: (h, params) => {
                    let poker = []
                    if (JSON.parse(params.row.opt_detail).award_content) {
                        poker = JSON.parse(params.row.opt_detail).award_content.point['0'].poker
                    }
                    return h('div', [
                        h('div', {
                            style: {
                                marginTop: '5px'
                            },
                            domProps: {
                                innerHTML: poker.map((x, index) => {
                                    return "<img style='width:35px;' src=img/poker/MJ/mingmah_" + (x == 10 ? 47 : Number(x) + 30) + '.png>'
                                })
                            }
                        })
                    ])
                }
            },
            {
                key: 'black',
                title: '总投注',
                align: 'center',
                render: (h, params) => {
                    let str = 0
                    let arr = JSON.parse(params.row.opt_detail).hits.hits
                    for (const key in arr) {
                        str += (this as any).getMoney(arr[key].bet, 1)
                    }
                    return h('span', Number(str).toFixed(2))
                }
            },
            {
                key: 'black',
                title: '总返奖',
                align: 'center',
                render: (h, params) => {
                    let str = (this as any).getMoney(params.row.chang_point)
                    let color = '#333'
                    if (str > 0) {
                        color = 'red'
                    } else if (str < 0) {
                        color = 'blue'
                    }
                    return h(
                        'span',
                        {
                            style: {
                                color: color
                            }
                        },
                        str
                    )
                }
            }
        ]
    }

    @Prop()
    listdata
}
